import { Pill, type PillTone } from './Pill'
import type { AccountStatus } from '../../lib/problem'

/**
 * An account status, in the one place that decides how each one looks.
 *
 * The dot carries the state as well as the colour, so the six statuses are not
 * distinguished by hue alone (WCAG 1.4.1) — and the label is always present, so
 * the colour is reinforcement rather than information.
 */
const TONE: Record<AccountStatus, PillTone> = {
  active: 'green',
  pending_approval: 'amber',
  suspended: 'rose',
  rejected: 'red',
  deleted: 'purple',
  purged: 'neutral',
}

const LABEL: Record<AccountStatus, string> = {
  active: 'Active',
  pending_approval: 'Pending approval',
  suspended: 'Suspended',
  rejected: 'Rejected',
  deleted: 'Deleted',
  purged: 'Purged',
}

export function StatusPill({ status }: { status: AccountStatus }) {
  return <Pill tone={TONE[status]} dot>{LABEL[status]}</Pill>
}
